import { createPublicApi } from '@htl/api';
import { createPublicHooks } from '@htl/hooks';
import { temporaryFallbacks } from './content/temporary';

const configuredBase = import.meta.env.VITE_API_BASE?.trim();
export const publicHooks = createPublicHooks(configuredBase ? createPublicApi(configuredBase) : undefined, temporaryFallbacks);

